import React, { useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as DayViewStyles from "../styles/dayView";

//COMPONENTS
import DetailsView from "./detailsView";

function MobileDayView(props) {
    const [detailsModal, setDetailsModal] = useState({
        open: false,
        event: []
    });

    function handleCloseDetailsModal() {
        setDetailsModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleOpenDetailsView(id) {
        const data = { id: id };

        Axios.post("/pods/events/getSingleEvent", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setDetailsModal((prevState) => {
                        return { ...prevState, open: true, event: data.event };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function getTHinDate(number) {
        if (number == "1" || number == "21" || number == "31") {
            return "st";
        } else if (number == "2" || number == "22") {
            return "nd";
        } else if (number == "3" || number == "23") {
            return "rd";
        } else {
            return "th";
        }
    }

    return (
        <div>
            <Modal show={props.open} centered onHide={props.modalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{`${props.dateNumber}${getTHinDate(props.dateNumber)} ${props.dateMonth}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.events.map((event, index) => {
                        return (
                            <div key={index}>
                                {event.timeType == "allDay" ? (
                                    <Row onClick={handleOpenDetailsView.bind(this, event.uuid)}>
                                        <Col style={{ ...DayViewStyles.eventBar, ...DayViewStyles.allDayColors }}>{`${event.title} (All Day)`}</Col>
                                    </Row>
                                ) : (
                                    <Row onClick={handleOpenDetailsView.bind(this, event.uuid)}>
                                        <Col
                                            style={{ ...DayViewStyles.eventBar, ...DayViewStyles.setTimesColors }}
                                        >{`${event.startTime}: ${event.title}`}</Col>
                                    </Row>
                                )}

                                <br />
                            </div>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.modalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
            <DetailsView open={detailsModal.open} close={handleCloseDetailsModal} event={detailsModal.event} />
        </div>
    );
}

export default MobileDayView;
